<template>
    <mc-container :title="title" :tips="errorType==='normal'?currentTips:''">
        <template class="mc-container__title" slot="title">
            <slot name="title_slot"></slot>
        </template>
        <div class="mc-input"
             :class="{
                'mc-input-group': $slots.prepend || $slots.append,
                'mc-input-group--prepend': $slots.prepend,
                'mc-input-group--append': $slots.append,
                'mc-input-tags': type==='tag',
                'is-focusing': focusing
             }"
             :style="{'min-height': type==='tag'?`${rows*32}px`:'0px'}"
             >
	        <!--<mc-tips placement="bottom" ref="popTip" show-type="event">-->
		        <!--<span slot="content" v-text="currentTips" class="mc-container__tips"></span>-->
			<mc-tag
					v-if="type === 'tag' && tags.length"
					v-for="(tag, idx) in tags"
					type="lowkey"
					:closable="!readonly"
					@close="closeTagHandler(tag, idx)"
					:key="idx"> {{tag}}
			</mc-tag>
	        <template v-if="type !== 'textarea'">
		        <div class="mc-input-group__prepend" v-if="$slots.prepend">
			        <slot name="prepend"></slot>
		        </div>
		        <input v-if="type==='tag'"
		               ref="input"
		               class="mc-input__text"
		               :maxlength="maxLength"
		               :disabled="inputDisabled"
		               :readonly="readonly"
		               :placeholder="placeholder"
		               v-model="tagInput"
		               @change="changeHandler"
		               @click="clickHandler"
		               @keyup="keyUpHandler"
		               @keydown="keyDownHandler"
		               @blur="blurHandler"
		               @focus="focusing=true"
		               :title="currentValue"
		               :class="{
                        'is-disabled': inputDisabled,
                        'is-error': !!currentTips
                    }">
		        <input v-if="type !== 'tag'"
				        :type="type"
		               ref="input"
		               class="mc-input__text"
		               :maxlength="maxLength"
		               :disabled="inputDisabled"
		               :readonly="readonly"
		               :placeholder="placeholder"
		               v-model="currentValue"
		               @change="changeHandler"
		               @click="clickHandler"
		               @keyup="keyUpHandler"
		               @keydown="keyDownHandler"
		               @blur="blurHandler"
		               :title="currentValue"
		               @input="inputHandler"
		               :class="{
                        'is-disabled': inputDisabled,
                        'is-error': !!currentTips
                    }">
		        <div class="mc-input-group__append" v-if="$slots.append">
			        <slot name="append"></slot>
		        </div>
	        </template>
            <textarea name="" v-if="type === 'textarea'"
                      :rows="rows"
                      class="mc-input__text"
                      :class="{
                        'is-disabled': inputDisabled,
                        'is-resize': inputResize,
                        'is-error': !!currentTips
                      }"
                      :maxlength="maxLength"
                      :value="currentValue"
                      :readonly="readonly"
                      @input="inputHandler"
                      @click="clickHandler"
                      @change="changeHandler"
                      @blur="blurHandler"
                      :disabled="inputDisabled"
                      :placeholder="placeholder">
            </textarea>
	        <!--</mc-tips>-->
	        <span class="mc-input__clean" v-if="!disabled && clearable && String(currentValue).length">
				<i class="fa fa-close-custom fa-input-icon" @click="clean"></i>
	        </span>
	        <span class="mc-input__suffix" v-if="!clearable && suffix && type === 'text'">
		        <i class="fa" :class="`fa-${suffix}`"></i>
	        </span>
            <span class="mc-input__counter" v-if="maxNumber && type==='textarea'" :class="{'is-over': Number(currentCount)>Number(maxNumber)}">
                {{currentCount}}/{{maxNumber}}
            </span>
        </div>

    </mc-container>

</template>
<script type="text/ecmascript-6">
    /**
     * 提供配置项 >>
     *  type          类型        text/textarea       DONE
     *  title         标题                            DONE
     *  value         绑定值                          DONE
     *  placeholder   占位文本                        DONE
     *  disabled      禁用                           DONE
     *  clearable     是否可清空                       DONE
     *  rows          行数（type=textarea时可用）      DONE
     *  resize          是否允许用户自行改变尺寸        DONE
     */
    import McContainer from './base-container';
    import McTag from './tag';
    import AsyncValidator from 'async-validator';
    import emitter from '../mixins/emitter';

    export default {
        name: 'mc-input',
        mixins: [emitter],
        inject: {
            McForm: {
                default: ''
            },
            mcFormItem: {
                default: ''
            }
        },
        components: {
            McContainer, McTag
        },
        slotData: [
            {
                name: 'default',
                type: ['select-option','select-group']
            },
            {
                name: 'title',
                type: ['text']
            }
        ],
        props: {
            type: {
                type: String,
                enumeration: ['text', 'textarea'],
                description: '文本框类型',
                default: 'text'
            },
	        maxLength: {
				type: Number,
		        description: '文本最大长度，与原生maxlength意义相同'
	        },
            title: {
                type: String,
                description: '组件标题'
            },
            tips: {
                type: String,
            },
            placeholder: {
                type: String,
                default: '',
                description: '占位提示文本'
            },
            disabled: {
                type: Boolean,
                description: '文本禁用',
                default: false
            },
            value: {
                type: [Number, String, Boolean],
                default: ''
            },
            clearable: {
                type: Boolean,
                description: '是否含有清除按钮',
                default: false
            },
            readonly: {
				type: Boolean,
	            description: '原生属性，是否只读',
	            default: false
            },
            rows: {
                type: Number,
                description: '文本框的行数（仅在type=textarea时有效）',
                default: 3
            },
            resize: {
                type: Boolean,
                description: '是否支持可以修改尺寸（仅在type=textarea时有效）',
                default: false
            },
            validateEvent: {
                type: Boolean,
                default: true
            },
            rules: {
                type: [Object, Array]
            },
            maxNumber: {
                type: Number,
                description: '文字输入字数上限（仅在type=textarea时有效）',
                default: 0
            },
            suffix: {
                type: String,
	            description: '输入框尾部的图标'
            },
	        splitKey: {
				type: [String, RegExp],
		        default: ',',
		        description: 'type=tag时，用来分割标签的字符'
	        },
	        errorType: {
                type: String,
                enumeration: ['normal', 'pop'],
		        description: '错误提示显示方式',
		        default: 'normal'
	        },
	        errorDuration: {
                type: Number,
		        description: '错误提示消息持续多长时间',
		        default: 1000
	        }
        },
        computed: {
            currentCount(e){
                if(this.type !== 'textarea'){
                    return
                }
                if(this.currentValue.length > this.maxNumber){
                    this.$emit('overLimited', e);
                }
                return this.currentValue.length
            }
        },
        data: function () {
            return {
                inputDisabled: !!this.disabled,
                inputResize: !!this.resize,
                currentValue: this.value,
	            tagInput: '',
                currentTips: this.tips,
                focusing: false,
	            tags: []
            }
        },
        watch: {
            value: function (val) {
	            this.setCurrentValue(val);

	            if (this.type === 'tag') {
	                this.updateTags();
	            }
            },
            tips: function (val) {
                this.currentTips = val;
            },
            disabled: function (val) {
	            this.inputDisabled = !!val;
            }
        },
        beforeMount(){
            this.updateTags();
        },
	    mounted(){
		    this.$on('resetValidate', this.resetValidateHandler)
	    },
        methods: {
            closeTagHandler(tag, index){
                const reg = new RegExp(`^(\\${this.splitKey}+)|(\\${this.splitKey}+)$`, 'g')
				this.tags.splice(index, 1);
                let tempValue = `${this.tags.join(this.splitKey)}${this.splitKey}${this.tagInput}`.replace(reg, '');
                this.setCurrentValue(tempValue);
				this.updateTags();
            },
            updateTags(){
                const reg = new RegExp(`^(\\${this.splitKey}+)|(\\${this.splitKey}+)$`, 'g')
                if(this.type !== 'tag' ||( this.currentValue === '' && this.tagInput === '')) {
                    this.tags = [];
                }else {
                    let tempValue = `${this.currentValue}${this.splitKey}${this.tagInput}`.replace(reg, '');
                    this.setCurrentValue(tempValue);
                    this.tags = this.currentValue.split(this.splitKey);
                    this.tagInput = '';
                    this.$emit('input', tempValue)
                }
            },
            setCurrentValue: function (val) {
                this.currentValue = val;
                this.rules && this.validate('change');
            },
            inputHandler: function (event) {
                let value = event.target.value;
                this.$emit('input', value);
                this.setCurrentValue(value);
            },
            changeHandler: function (event) {
                let value = event.target.value;
                this.$emit('change', value);
                if (this.validateEvent) {
                    this.dispatch('mcFormItem', 'el.form.change', [value]);
                }
            },
            clickHandler: function (event) {
	            this.$emit('click', event);
            },
            keyUpHandler: function () {
	            this.$emit('keyup')
            },
            keyDownHandler: function (e) {
                if(e.key === 'Enter'){
					this.updateTags();
                }
                this.$emit('keydown')
            },
            /**
             * 处理blur事件
             * @param event
             */
            blurHandler: function (event) {
                this.focusing = false;
                this.updateTags();
                this.rules && this.validate('blur');
                this.$emit('blur', event);
                if (this.validateEvent) {
                    this.dispatch('mcFormItem', 'el.form.blur', [this.currentValue]);
                }
            },
	        // 清空校验
            resetValidateHandler: function () {
	            this.currentTips = '';
            },
            /**
             * 判断输入内容
             * @param trigger
             * @param callback
             */
            validate: function (trigger, callback = function () {}) {
                let rule = this.getRules(trigger);
                if(!rule || !rule.length){
                    return false
                }
                const schema = new AsyncValidator({name: rule});
                schema.validate({name: this.currentValue}, (errors, field) => {
                    if(errors){
                        this.currentTips = errors[0].message;
	                    if(this.errorType === 'pop' && this.currentTips && false){
							this.$refs.popTip.showHandler();
							setTimeout(()=>{
                                this.$refs.popTip.closeHandler();
							}, 1000)
	                    }
                    }else{
                        this.currentTips = ''
                    }
                })
            },
            /**
             * 获取判断规则
             * @param trigger
             */
            getRules: function (trigger) {
                //过滤掉trigger为空和trigger传入参数不一致的rule
                return this.rules.filter(rule => !rule.trigger || rule.trigger.indexOf(trigger) !== -1)
            },
            clean: function () {
                this.currentValue = '';
                this.$emit('change', this.currentValue);
                this.$emit('input', this.currentValue);
                this.rules && this.validate('change');
                if (this.validateEvent) {
                    this.dispatch('mcFormItem', 'el.form.change', [this.currentValue]);
                }
                this.$nextTick(()=>{
                    this.$refs.input.focus();
                });
            }
        }
    }
</script>

<style lang="scss" scoped>
    /*@import '~mcui';*/
</style>



// WEBPACK FOOTER //
// src/components/base-input.vue